document.addEventListener('DOMContentLoaded', function() {
    function createInfiniteCarousel(selector, duration = 25) {
        const carousel = document.querySelector(selector);
        if (!carousel) return;
        
        const track = carousel.querySelector('.logo-track');
        if (!track) return;
        
        // Calculate the width of half the content (since we duplicated logos)
        const trackWidth = track.scrollWidth / 2;
        
        // Create infinite timeline
        const tl = gsap.timeline({ repeat: -1 });
        
        tl.to(track, {
            x: -trackWidth,
            duration: duration,
            ease: "none" // Linear movement for smooth carousel
        });
        
        // Pause on hover
        carousel.addEventListener('mouseenter', () => {
            tl.pause();
        });
        
        carousel.addEventListener('mouseleave', () => {
            tl.resume();
        });
        
        return tl;
    }

    // Initialize the carousel
    createInfiniteCarousel('.logo-carousel', 60); // Adjust duration for speed (lower = faster)
});